import { Component } from '@angular/core';

@Component({
  selector: 'app-circles-background',
  templateUrl: './circles-background.component.html',
  styleUrls: ['./circles-background.component.scss']
})
export class CirclesBackgroundComponent {}
